module.exports = new __parcel__URL__("peter.beae43c5.webp").toString();